import { AbstractModel } from './AbstractModel'

export class RallyRoundDefaultTeamlogo extends AbstractModel {
    public id: number|null = null
    public minioRessourceId: number|null = null
}
